import { render, staticRenderFns } from "./aquit-alert.vue?vue&type=template&id=ba8625de"
import script from "./aquit-alert.vue?vue&type=script&lang=js"
export * from "./aquit-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports